import { render, staticRenderFns } from "./QuoteExtraction.vue?vue&type=template&id=1d65cedc"
import script from "./QuoteExtraction.vue?vue&type=script&lang=js"
export * from "./QuoteExtraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports